import { getIcon, IconName } from '../../../common/components/icons/utils'
import { ReportSortDir } from '../../../contexts/ReportsContextProvider'
import styles from './ReportCommon.module.css'
import genericTable from './GenericTable.module.css'
import classNames from 'classnames'
import { useState } from 'react'
import { GraphData } from './ReportHelper'
import { Tooltip } from '../../../common/components/tooltip/Tooltip'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

interface SummaryDataBoxProps {
  iconName: IconName
  value?: number | string
  label: string
  toolTipText?: string
}

export const SummaryDataBox: React.FC<SummaryDataBoxProps> = ({ iconName, value, label, toolTipText }) => {
  return (
    <>
      {toolTipText ? (
        <Tooltip key={iconName} tooltipContent={toolTipText + ''}>
          {(tooltipProps) => (
            <div className={styles.summaryDataBox} {...tooltipProps}>
              <div className={styles.summaryDataIconContainer}>{getIcon(iconName)}</div>
              <div className={styles.summaryBoxLargeText}>{value}</div>
              <div className={styles.summaryBoxPinkText}>{label}</div>
            </div>
          )}
        </Tooltip>
      ) : (
        <div className={styles.summaryDataBox}>
          <div className={styles.summaryDataIconContainer}>{getIcon(iconName)}</div>
          <div className={styles.summaryBoxLargeText}>{value}</div>
          <div className={styles.summaryBoxPinkText}>{label}</div>
        </div>
      )}
    </>
  )
}

interface HeaderSorterProps {
  isActive?: boolean
  label: string
  onSort?: (direction: ReportSortDir) => void
  activeSortDir?: ReportSortDir
}

export const HeaderSorter: React.FC<HeaderSorterProps> = ({ isActive, label, onSort, activeSortDir }) => {
  const [activeDir, setActiveDir] = useState(activeSortDir)
  const sortAsc = () => {
    setActiveDir(ReportSortDir.ASC)
    if (onSort) onSort(ReportSortDir.ASC)
  }
  const sortDesc = () => {
    setActiveDir(ReportSortDir.DESC)
    if (onSort) onSort(ReportSortDir.DESC)
  }
  return (
    <th>
      <div className={genericTable.headerCell}>
        {onSort ? (
          <div className={genericTable.headerSorter}>
            <div
              className={isActive && activeDir === ReportSortDir.ASC ? genericTable.activeDir : ''}
              onClick={sortAsc}
            >
              {getIcon('chevron')}
            </div>
            <div
              className={isActive && activeDir === ReportSortDir.DESC ? genericTable.activeDir : ''}
              onClick={sortDesc}
            >
              {getIcon('chevron')}
            </div>
          </div>
        ) : (
          <div />
        )}
        <div className={classNames(genericTable.headerLabe, isActive && genericTable.bold)}>{label}</div>
      </div>
    </th>
  )
}

interface BarGraphProps {
  graphData: GraphData
}

export const BarGraph: React.FC<BarGraphProps> = ({ graphData }) => {
  const labels = JSON.parse(JSON.stringify(graphData.valueLabels)).reverse() as number[]
  const rounder = graphData.maxValue > 100 ? 10 : 0

  return (
    <div className={styles.playerGraphHolder}>
      {labels.map((label, index) => {
        const displayLabel = rounder > 0 ? Math.round((label + rounder) / rounder) * rounder : label.toFixed()
        return (
          <div key={index} className={styles.playerGraphLine}>
            <div className={styles.playerGraphLineValue}>
              {graphData.maxValue < 4 && [1, 3].includes(index)
                ? ''
                : graphData.maxValue === 3 && index === 2
                ? '1.5'
                : graphData.maxValue === 1 && index === 2
                ? ''
                : displayLabel}
            </div>
          </div>
        )
      })}
      <div className={styles.barRow}>
        {graphData.barValues.map((value, index) => {
          return (
            <Tooltip key={index} timeoutMs={10} tooltipContent={value + ''}>
              {(tooltipProps) => (
                <div
                  style={{ height: graphData.maxValue > 0 ? 100 * (value / graphData.maxValue) + '%' : 0 }}
                  className={styles.bar}
                  {...tooltipProps}
                >
                  {/*value*/}
                </div>
              )}
            </Tooltip>
          )
        })}
      </div>
      <div className={styles.barLabelRow}>
        {graphData.barLabels.map((label, index) => {
          return (
            <div key={index} className={styles.barLabel}>
              {label}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const createPDFfromHTML = (elementId: string, docName: string): void => {
  const element = document.getElementById(elementId) as HTMLElement
  var HTML_Width = element.clientWidth
  var HTML_Height = element.clientHeight
  var top_left_margin = 15
  var PDF_Width = HTML_Width + top_left_margin * 2
  var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2
  var canvas_image_width = HTML_Width
  var canvas_image_height = HTML_Height

  var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1

  html2canvas(element, { useCORS: true }).then(function (canvas) {
    var imgData = canvas.toDataURL('image/jpeg', 1.0)
    var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
    pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)
    for (var i = 1; i <= totalPDFPages; i++) {
      pdf.addPage([PDF_Width, PDF_Height])
      pdf.addImage(
        imgData,
        'JPG',
        top_left_margin,
        -(PDF_Height * i) + top_left_margin * 4,
        canvas_image_width,
        canvas_image_height,
      )
    }
    pdf.save(docName + '.pdf')
  })
}
